/**
 * @description 应用启动时预拉取商城分类树，供 Header / Footer / 商品列表等 PC 与移动端共用
 */
export default defineNuxtPlugin(() => {
  if (!import.meta.client) return

  const userStore = useUserStore()
  const categoryStore = useCategoryStore()

  userStore.restoreImsTokenFromCookies()
  categoryStore.ensureCategoryTreeState()

  // 非阻塞拉取：不 await，避免在客户端挂载前就填好分类，导致与服务端空壳产生 hydration mismatch。
  categoryStore.fetchCategoryInfo().catch((error) => {
    console.error('[category-init] Failed to load category tree:', error)
  })
})
